import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useCookies } from 'react-cookie'

import { Modal, Button } from '@resurs/midas-react'
import { useLocaleActions } from '@merchant-portal/merchant-portal-base'

import { logout } from '../../../store/actions/auth-actions'
import { resetTransactions } from '../../../store/actions/transactions-actions'
import { getText } from '../../TextLabels'

const AdvanceSettingsModal = props => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isReportButtonDisabled, setIsReportButtonDisabled] = useState(true)

  const [, , removeCookie] = useCookies(['store', 'country'])
  const localeActions = useLocaleActions()

  const handleLogout = e => {
    e.preventDefault()

    localStorage.removeItem('push-out-checked')
    removeCookie('store')
    removeCookie('country')
    localeActions.setLanguage('')
    localeActions.setCountry('')
    props.resetTransactions()

    props.logout()
  }

  const onLogoutClicked = e => {
    e.preventDefault()
    setIsModalOpen(true)
  }

  const saveCurrentUserStore = () => {
    if (isReportButtonDisabled) {
      setIsReportButtonDisabled(false)
      setIsModalOpen(false)
    }
  }

  return (
    <div style={{ width: '100%', textAlign: 'center', paddingBottom: '1rem' }}>
      <a
        href="#"
        style={{ color: '#CCC', textDecoration: 'none' }}
        onClick={e => onLogoutClicked(e)}
      >
        ...
      </a>
      {isModalOpen && (
        <Modal
          show={isModalOpen}
          title={getText('menu.header.title')}
          onClose={() => setIsModalOpen(false)}
          actions={
            <>
              <span style={{ float: 'left' }}>
                <Button onClick={() => setIsModalOpen(false)}>
                  {getText('default.cancel')}{' '}
                </Button>
              </span>
              <Button
                onClick={saveCurrentUserStore}
                disabled={!isReportButtonDisabled}
              >
                {getText('menu.header.sendData.title')}
              </Button>
              <span style={{ paddingLeft: '1rem' }} />
              <Button type="primary" onClick={e => handleLogout(e)}>
                {getText('menu.header.resetData.title')}
              </Button>
            </>
          }
        >
          <div style={{ textAlign: 'left' }}>
            <h6>{getText('menu.header.resetData.title')}</h6>
            <p>{getText('menu.header.resetData.description')}</p>
            <h6>{getText('menu.header.sendData.title')}</h6>
            <p>{getText('menu.header.sendData.description')}</p>
          </div>
        </Modal>
      )}
    </div>
  )
}

AdvanceSettingsModal.propTypes = {
  logout: PropTypes.func.isRequired,
  resetTransactions: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(logout())
  },
  resetTransactions: () => {
    dispatch(resetTransactions())
  },
})

export default connect(null, mapDispatchToProps)(AdvanceSettingsModal)
